import Glider from 'glider-js/glider'; 

export default () => {
    let gliderCarousel = document.querySelectorAll('.js-carousel');
    if (gliderCarousel){ 
      gliderCarousel.forEach(element => {
        let initGlider = new Glider(element, {
          slidesToShow: 2.5,
          slidesToScroll: 1.75, 
          draggable: true,
        });
        initGlider.setOption({
            arrows: {
                prev: element.nextElementSibling.querySelector('.js-carousel-prev.glider-prev'),
                next: element.nextElementSibling.querySelector('.js-carousel-next.glider-next'),
            },
            responsive: [
              { 
                breakpoint: 480,
                  settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1.75
                  }
              },
              { 
                breakpoint: 640,
                  settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 2.75
                  }
              },
              { 
                breakpoint: 1024,
                  settings: {
                    slidesToShow: 6.5,
                    slidesToScroll: 5.75
                  }
                }
              ]
        });
        initGlider.refresh(true);
    });
    }
}